import React from "react";
import "./Home.css";
import { Typewriter } from "react-simple-typewriter";
import { FaFacebook, FaInstagram, FaLinkedin,FaGithub } from "react-icons/fa";
import {
  DiCss3,
  DiGit,
  DiHtml5,
  DiJavascript,
  DiMongodb,
  DiReact,
} from "react-icons/di";

const Home = () => {

  const handleType = (count) => {
    console.log(count)
  }

  const handleDone = () => {
    console.log(`Done after 5 loops!`)
  }
 
  return (
    <>
      <section className="hero" id="home">
        <div className="container f_flex top">
          <div className="left top">
            <h3>WELCOME TO MY WORLD</h3>
            <h1>
              Hi, I’m <span>Suraj Badwaik</span>
            </h1>
            <h2>
              a
              <span>
                <Typewriter
                  words={[" MERN DEVELOPER.", " Professional Coder."]}
                  loop={5}
                  cursor
                  cursorStyle="|"
                  typeSpeed={70}
                  deleteSpeed={50}
                  delaySpeed={1000}   
                  onLoopDone={handleDone}
                  onType={handleType}        
                />
              </span>
            </h2>

            <p>
            I have passion of developing scalable web applications and working across the full stack. I am looking to join an organisation where I can continue to grow my skill set.
            </p>

            <div className="hero_btn d_flex">
              <div className="col_1">
                <h4>FIND ME WITH</h4>
                <div className="button">
                  <button className="btn_shadow">
                    <a
                      href="https://www.facebook.com/suraj.badwaik.52"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaFacebook color="blue" />
                    </a>
                  </button>
                  <button className="btn_shadow">
                    <a
                      href="https://www.instagram.com/suraj_k_badwaik/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaInstagram color="#ff014f" />
                    </a>
                  </button>
                  <button className="btn_shadow">
                    <a
                      href="https://www.linkedin.com/in/suraj-badwaik/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaLinkedin color="#1b88f5" />
                    </a>
                  </button>
                  <button className="btn_shadow">
                    <a
                      href="https://github.com/Suraj-Badwaik"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaGithub color="black" />
                    </a>
                  </button>
                </div>
              </div>
              <div className="col_1">
                <h4>BEST SKILL ON</h4>
                <div className="grid_skills">
                  <button className="btn_shadow">
                    <DiJavascript color="#e4bb02" />
                  </button>
                  <button className="btn_shadow">
                    <DiReact color="#046e8" />
                  </button>
                  <button className="btn_shadow">
                    <DiHtml5 color="#e37405" />
                  </button>
                  <button className="btn_shadow">
                    <DiCss3 color="#0079ff" />
                  </button>
                  <button className="btn_shadow">
                    <DiMongodb color="#039f03" />
                  </button>
                  <button className="btn_shadow">
                    <DiGit color="#ff6c00" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="right">
            <div className="right_img">
              <img
                src="https://i.postimg.cc/CxBzM8WG/DSC-8114-8x10-removebg-preview-1.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
